import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=2445fbee&"
import script from "./sales.vue?vue&type=script&lang=js&"
export * from "./sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2445fbee')) {
      api.createRecord('2445fbee', component.options)
    } else {
      api.reload('2445fbee', component.options)
    }
    module.hot.accept("./sales.vue?vue&type=template&id=2445fbee&", function () {
      api.rerender('2445fbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/sales.vue"
export default component.exports